<template>
  <div class="flex">
    <filter-field-default
      label="Leads created"
      v-model="currentTimeframe"
    >
      <option
        v-for="option in funnelTimeframeOptions"
        :key="option.value"
        :value="option.value"
      >{{ option.label }}</option>
    </filter-field-default>

    <filter-field-date
      v-if="funnelTimeframeIsCustom"
      v-model="funnelCustomDates"
      :is-range="true"
      @change="applyFilter(false)"
    ></filter-field-date>

    <filter-field-dropdown
      ref="dropdown"
      label="Filter Funnel"
      icon-left="filter"
      :is-disabled="isLoading"
    >
      <template v-if="isUsingCampaignFilterFilter">
        <form-field-checkbox-group
          label="Campaigns"
          :items="campaigns"
          v-model="filterCampaignFilter"
          @selectAll="selectAllCampaigns"
          @deselectAll="deselectAllCampaigns"
          @change="filterChanged"
        ></form-field-checkbox-group>
      </template>

      <p v-if="showCheckboxError" class="mb-0 has-text-danger">Please check at least one checkbox above</p>

      <div class="level-item">
        <button-default
          :disabled="filterCampaignFilter.length === 0"
          @click="applyFilter(true)"
        >
          Apply Filter
        </button-default>
      </div>
    </filter-field-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
    campaignFilter: Array,
    isUsingCampaignFilter: Boolean,
    funnelTimeframe: Number
  },
  data() {
    return {
      filterCampaignFilter: this.campaignFilter,
      isUsingCampaignFilterFilter: this.isUsingCampaignFilter,
      funnelTimeframeFilter: this.funnelTimeframe,
      funnelTimeframeIsCustom: false,
      funnelCustomDates: [],
      showCheckboxError: false,
    }
  },
  mounted() {
    if(this.filterCampaignFilter.length === 0) {
      this.showCheckboxError = true;
    }
  },
  computed: {
    campaigns() {
      return [
        { id: null, label: 'No Campaign' },
        ...this.$store.getters.activeCampaigns,
      ];
    },
    currentTimeframe: {
      get() {
        return this.funnelTimeframe;
      },
      set(value) {
        this.funnelTimeframeFilter = value;

        if (value === 8) {
          this.showDatePicker();
        } else {
          this.hideDatePicker();

          this.applyFilter(false);
        }
      }
    },
    funnelTimeframeOptions() {
      return [
        { value: 1, label: 'Today' },
        { value: 2, label: 'Last 7 Days' },
        { value: 3, label: 'Last 14 Days' },
        { value: 4, label: 'Last Month' },
        { value: 5, label: 'Last 3 Months' },
        { value: 6, label: 'Last 6 Months' },
        { value: 7, label: 'Last Year' },
        { value: 8, label: 'Custom' },
      ];
    },
  },
  methods: {
    selectAllCampaigns() {
      const campaigns = this.$utils.clone(this.$store.getters.activeCampaigns);
      this.filterCampaignFilter = campaigns.map(c => c.id);
      this.filterCampaignFilter.push(null);
      this.showCheckboxError = false;
    },
    deselectAllCampaigns() {
      this.filterCampaignFilter = [];
      this.showCheckboxError = true;
    },
    applyFilter(toggle) {
      if(this.filterCampaignFilter.length === 0) {
        this.showCheckboxError = true;
        return;
      } else {
        this.showCheckboxError = false;
      }

      if (toggle) {
        this.$refs.dropdown.toggle();
      }

      this.$emit('applyFilter', {
        campaigns: this.filterCampaignFilter,
        isUsingCampaignFilter: this.isUsingCampaignFilterFilter,
        funnelTimeframe: this.funnelTimeframeFilter,
        funnelCustomDates: this.funnelCustomDates,
      });
    },
    applyCustomDates() {
      this.funnelTimeframeFilter = this.funnelTimeframeOptions[this.funnelTimeframeOptions.length - 1].value;
      this.$refs.funnelTimeframeDropdown.toggle();
      this.applyFilter();
    },
    showDatePicker() {
      this.funnelTimeframeIsCustom = true;
    },
    hideDatePicker() {
      this.funnelCustomDates = [];
      this.funnelTimeframeIsCustom = false;
    },
    filterChanged() {
      this.showCheckboxError = this.filterCampaignFilter.length === 0;
    }
  },
}
</script>

<style lang="scss">
@import "../../../styles/variables/variables";

</style>
